'use strict';

let Labels = {
    initialized: false,
    more: "",
    noItemsFound: "No products matching your criteria were found",
    searchPlaceholder: "Search for a specific product",
    searchButton: "Search",
    showMore: "Show more",
    tab1: "Safety Data Sheets",
    tab2: "Other Downloads",
    availableSdsFiles: "SDS files for",
    bestSdsFile: "Based on your current location and language, you might be interested in this file:",
    noBestFile: "", //"We could not find an exact match for your location and language.",
    alternativeSdsFiles: "Please choose one of the available SDS files below. You can use the region selector to filter the list of available files.", //"As an alternative, you can download one of the other SDS files for this product:",
    noSDSFiles: "No Safety Data Sheets are available online for this product. Please contact our <a href='/company/contacts-and-locations/business-unit-contacts' target='_blank'>Service Desk</a>.",
    noOtherFiles: "No other files are available online for this product. Please contact our <a href='/company/contacts-and-locations/business-unit-contacts' target='_blank'>Service Desk</a>.",
    generating: "Generating file. Download will start shortly...",
    anyCountry: "Any country",
    noResults: "We could not find any products matching your search criteria.",
    tooManyResults: "Your query returned more than 100 products. Please consider rephrasing your search terms.",
    resultCount: "Matching products: {count}",
    searchDescription: "If the file you are looking for is not available online, please reach out to our <a target='_blank' href='/company/contacts-and-locations/business-unit-contacts'>Service Desk</a>.",
    pleaseWait: "Please wait until your current download completes",
    currentRegion: "Country or Region",
    get (name) {
        if (this.initialized === false) this.init();
        if (this.hasOwnProperty(name)) return this[name];
        return "Undefined";
    },
    init() {
        let labelEls = document.querySelectorAll(".doc-finder-params > .labels > input[type='hidden']");
        if (labelEls && labelEls.length > 0) {
            for (let i = 0; i < labelEls.length; i++) {
                const el = labelEls[i];
                this[el.name] = el.value;
            };
        }
        this.initialized = true;
    }
};

export default Labels;